import { delay } from 'redux-saga'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'

import {
  PUSH
} from './constants'

import {
  pushStart,
  pushSuccess,
  updateRedirect,
  updateTo
} from './actions'

function* clear() {
  yield put(updateRedirect(false))
  yield put(updateTo(''))
}

function* handlePush(action) {
  const { to, redirect } = action
  yield put(pushStart())
  yield put(updateRedirect(redirect))
  yield put(updateTo(to))
  yield put(pushSuccess())
}

function* watchPush() {
  yield takeLatest(PUSH, handlePush)
}

function* loadSagas() {
  yield all([
    fork(watchPush)
  ])
}

export default loadSagas
